import axios from "axios";
import toast from "react-hot-toast";
import config from "../config";
import { currentAgentTokenVar } from "../_graphql/cache/auth";

export type ErrorBag = Record<string, string[]>;

const baseURL = config.ai.uri;

const artificialInstance = axios.create({
    baseURL: baseURL,
    headers: {
        accept: "application/json",
    },
});

artificialInstance.interceptors.request.use((config) => {
    let access_token = currentAgentTokenVar();
    const session_id = localStorage.getItem("__a_session_id");
    if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    if (session_id) {
        config.headers["X-Session-Id"] = session_id;
    }

    return config;
});

// Create errorBag Interface
export const errorHandler = (errorBag: ErrorBag) => {
    Object.entries(errorBag).map(([key, value]) => {
        value.map((error: string) => {
            toast.error(`${key} ${error}`);
        });
    });
};

export default artificialInstance;
